export default "__VITE_ASSET__8494c7b7__"